module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/arrow_martech-9e02e836dd97d5f2a653ed575eb9ae66.svg";